<div class="container-fluid bg-primary">
    <div>
        <div *ngIf="invite.Status" class="mt-100">
             <div class="row" >
                <div class="col-md-6 col-md-offset-3">
                    <p id ="h1">Scan {{this.labels.VISITOR_PASS}} below for entry:<p>
                    <table class="table table-sm" style="margin:auto">
                        <tbody>
                            <tr>
                                <td> {{this.labels.VISITOR_PASS}} Name </td>
                                <td> {{invite.InviteName}}</td>
                            </tr>
                            <tr *ngIf="invite.StartDate && invite.EndDate">
                                <td> Start & End Date</td>
                                <td> {{invite.StartDate}} to {{invite.EndDate}} </td>
                            </tr>
                            <tr>
                              <td>Locations</td>
                              <td class="comma-list">
                                <span *ngFor="let loc of invite.Properties">{{loc}} </span>
                              </td>
                            </tr>                           
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" >
                <p class="" id ="h1"> DO NOT SCREENSHOT QR CODE BELOW</p>            
              </div>
            <div class="row" id="values" >
                <div class="col-md-6 col-md-offset-3">
                    <img id="barcodeImage" [src]="'data:image/png;base64,'+ invite.Result" />
                </div>
            </div>
            <div class="row" >
                <p class="" id="h1" >  The QR Code refreshes on every use. <br>Once this code is used refresh the page to generate the new code.</p>
             <br>
              </div>
              
              <!-- <div class="row text-center" >
                <button (click)="GenerateQRCode()" ><img class="brand-btn-qrcode" src="assets/brandIcons/Generate_QR_code.svg"></button>
             <br>
              </div> -->
          
        </div>
        <div *ngIf="!invite.Status" class="mt-100">
            {{invite.Result}}
        </div>
    </div>
